import React, { useEffect, useRef, useState } from 'react';
import apiClient from '@/services/apiClient';

/** Supplier goods (and trims) can only be confirmed when the supplier has an open PO for the section — the PO itself is picked later in the section. */
export const needsPo = (parcelType, partyType) => ['goods', 'trims'].includes(parcelType || 'goods') && partyType !== 'customer';

/** Shows whether this supplier has an open Purchase Order for the delivery's section (confirm is blocked when not). onBlocked(bool) reports it. */
export const OpenPoBadge = ({ entryId, vendorName, section, onBlocked }) => {
  const [d, setD] = useState(undefined); // undefined = still checking (confirm held), null = no answer
  const cb = useRef(onBlocked);
  cb.current = onBlocked;
  useEffect(() => {
    let live = true;
    setD(undefined);
    if (!vendorName || !section) { setD(null); return undefined; }
    apiClient.get('/documentation/po-options', { params: { vendor_name: vendorName, section } })
      .then((r) => live && setD(r.data)).catch(() => live && setD(null));
    return () => { live = false; };
  }, [vendorName, section]);
  const blocked = d === undefined || !!(d && d.required && !d.pos.length);
  useEffect(() => { cb.current?.(blocked); }, [blocked]);
  useEffect(() => () => cb.current?.(false), []);
  if (!d || !d.required) return null;
  if (!d.pos.length) {
    return <span className="text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded px-2 py-1" data-testid={`po-none-${entryId}`}>
      No open {section} PO for this supplier — can't confirm</span>;
  }
  return <span className="text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 rounded px-2 py-1 font-mono" data-testid={`po-open-${entryId}`}
    title={d.pos.map((p) => p.po_number).join(', ')}>
    Open PO {d.pos[0].po_number}{d.pos.length > 1 ? ` +${d.pos.length - 1}` : ''}</span>;
};
